import React from "react";
import { Pages } from "../../utils/constants";
import Card from "../Basic/Card";
import bgForm from "../../assets/background/bg-form-top-navy-dark.svg";
import { ReactComponent as CCMIcon } from "../../assets/icons/ccm-green.svg";
import { ReactComponent as ScribeIcon } from "../../assets/icons/microphone-green.svg";
import { ReactComponent as AdminIcon } from "../../assets/icons/file-green.svg";

const CheckIn = () => {
  return (
    <div className="relative">
      <img
        src={bgForm}
        alt="background"
        className="w-full -mb-1"
        width="1440"
        height="93"
        fetchpriority="high"
      />

      <div className="px-5 lg:px-10 py-14 lg:py-30 bg-navy-dark rounded-t -mb-1">
        <div className="w-full lg:max-w-7xl mx-auto relative z-10">
          <div
            className="text-[26px] lg:text-16 leading-[1.23] lg:leading-tight mb-5 lg:mb-6 header
              flex flex-col items-center mx-auto"
          >
            <h2 className="text-white">Automate</h2>
            <div className="h-8 lg:h-21 overflow-hidden">
              <div
                className="text-green-primary flex flex-col items-center animate-text-slide-up-mobile
                  lg:animate-text-slide-up relative top-0"
              >
                <p>patient check-ins</p>
                <p>post-visit documentation</p>
                <p>customized intake</p>
                <p>reporting and compliance</p>
                <p>patient check-ins</p>
              </div>
            </div>
          </div>

          <p className="text-base lg:text-2xl text-center text-gray-300 mb-8 lg:mb-20">
            Scale up your care team with Quadrant AI assistants.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 h-fit">
            <Card
              icon={<CCMIcon width="24" height="24" />}
              title="AI Care Management"
              desc="Provide longitudinal care. Drive revenue growth."
              points={[
                "Manage 3x more patients vs other leading tools",
                "Automate patient outreach",
                "Retain more patients with personalization",
              ]}
              link={Pages.CARE_MANAGEMENT}
              className="h-full"
            />
            <Card
              icon={<ScribeIcon width="24" height="24" />}
              title="AI Scribe"
              desc="Eliminate documentation burden and delight your staff."
              points={[
                "95% decrease in charting time",
                "Advanced domain-specific medical AI",
                "Integrated across your existing tools",
              ]}
              link={Pages.SCRIBE}
              className="h-full"
            />
            <Card
              icon={<AdminIcon width="24" height="24" />}
              title="AI Admin"
              desc="Blaze through scheduling, referrals, refills, and bill pay."
              points={[
                "Handle 70% of inbound automatically",
                "Streamlined message review and triage",
                "Identify exact next steps and tasks",
              ]}
              link={Pages.ADMINISTRATIVE}
              className="h-full"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckIn;
